import { jsx, jsxs } from "react/jsx-runtime";
import { IconWrapper } from "../IconWrapper/index.js";
import '../../assets/index8.css';const spinner = "_spinner_a4581_1";
const spinnerAnimation = "_spinnerAnimation_a4581_1";
const s = {
  spinner,
  spinnerAnimation
};
const AnimationSpinner = ({ size = "sm" }) => /* @__PURE__ */ jsx(IconWrapper, { size, children: /* @__PURE__ */ jsxs(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: s.spinner,
    children: [
      /* @__PURE__ */ jsx("g", { "clip-path": "url(#paint0_angular_113_2369_clip_path)", "data-figma-skip-parse": "true", children: /* @__PURE__ */ jsx("g", { transform: "matrix(0 0.01 -0.01 0 10 10)", children: /* @__PURE__ */ jsx("foreignObject", { x: "-1100", y: "-1100", width: "2200", height: "2200", children: /* @__PURE__ */ jsx(
        "div",
        {
          style: {
            background: "conic-gradient(from 90deg,rgba(255, 255, 255, 0) 0deg,rgba(255, 255, 255, 1) 360deg)",
            height: "100%",
            width: "100%",
            opacity: 1
          }
        }
      ) }) }) }),
      /* @__PURE__ */ jsx(
        "path",
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17Z",
          "data-figma-gradient-fill": '{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":1.0,"g":1.0,"b":1.0,"a":0.0},"position":0.0},{"color":{"r":1.0,"g":1.0,"b":1.0,"a":1.0},"position":1.0}],"stopsVar":[],"transform":{"m00":1.2246467996456087e-15,"m01":-20.0,"m02":20.0,"m10":20.0,"m11":1.2246467996456087e-15,"m12":0.0},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
        }
      ),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "paint0_angular_113_2369_clip_path", children: /* @__PURE__ */ jsx(
        "path",
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17Z"
        }
      ) }) })
    ]
  }
) });
export {
  AnimationSpinner
};
